module.exports = __webpack_public_path__ + "static/img/no_mubu.1cf85cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/no_mubu.png
// module id = Ou6e
// module chunks = 1